import { Snackbar } from "@material-ui/core";

import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import BanqueService from "../../services/Banque";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DetailBanque from "../../components/finance/banque/DetailBanque";
import DetailCompteCaisse from "../../components/finance/compteCaisse/DetailcompteCaisse";

const AddBanqueAccount = () => {
  const [ribNumber, setRibNumber] = useState("");
  const [bankAndAgenceData, setBankAndAgenceData] = useState([]);
  const [bankName, setBankName] = useState("");
  const [agenceName, setAgenceName] = useState("");
  const [agenceLocalisation, setAgenceLocalisation] = useState("");
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setsuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [selectedBanqueOption, setSelectedBanqueOption] = useState(null);
  const [selectedAgenceOption, setSelectedAgenceOption] = useState(null);
  const [banqueOptions, setBanqueOptions] = useState([]);
  const [ageneOptions, setAgeneOptions] = useState([]);
  const [banqueId, setBanqueId] = useState(0);
  const [agenceId, setAgenceId] = useState(0);

  const [addAgence, setAddAgence] = useState(false);
  const [addBankAndAgence, setAddBankAndAgence] = useState(false);
  const [type, setType] = useState("Banque");
  useEffect(() => {
    BanqueService.getAllAgenceAndBank(getCurrentUserId())
      .then((response) => {
        console.log(response);
        if (Object.keys(response.data)[0] === "empty") {
          setBankAndAgenceData([]);
        } else {
          setBankAndAgenceData(response.data.success);
          remplissageOption(response.data.success);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
    setType("BANQUE");
  }, []);

  const remplissageOption = (data) => {
    let idBankss = [];
    data.map((element) => {
      if (!idBankss.includes(element.idBank)) {
        idBankss.push(element.idBank);

        setBanqueOptions((prevState) => [
          ...prevState,
          { value: element.idBank, label: element.bankName },
        ]);
      }
    });

    console.log(banqueOptions);
  };

  const isANumber = (input, length) => {
    if (
      input[length - 1] === "0" ||
      input[length - 1] === "1" ||
      input[length - 1] === "2" ||
      input[length - 1] === "3" ||
      input[length - 1] === "4" ||
      input[length - 1] === "5" ||
      input[length - 1] === "6" ||
      input[length - 1] === "7" ||
      input[length - 1] === "8" ||
      input[length - 1] === "9"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleChangeBanque = (selectedOptionn) => {
    setSelectedBanqueOption();
    setBanqueId(selectedOptionn.value);
    setAgeneOptions([]);
    setAgenceId(0);
    setSelectedAgenceOption(null);

    bankAndAgenceData.map((element) => {
      if (element.idBank === selectedOptionn.value) {
        setAgeneOptions((prevState) => [
          ...prevState,
          { value: element.idAgence, label: element.agenceName },
        ]);
      }
    });
  };

  const addBanqueHandler = () => {
    setAddBankAndAgence(true);
    setAgenceId(0);
    setBanqueId(0);
  };

  const addAgenceHandler = () => {
    setAddAgence(true);
    setAgenceId(0);
  };

  const handleChangeAgence = (selectedOptionn) => {
    setSelectedAgenceOption();
    setAgenceId(selectedOptionn.value);
    //heere

    bankAndAgenceData.map((element) => {
      if (element.idAgence === selectedOptionn.label) {
        setBanqueOptions((prevState) => [
          ...prevState,
          { value: element.idBank, label: element.bankName },
        ]);
      }
    });
  };
  console.log(type, "Type");
  function handleChange() {
    if (type === "BANQUE") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">
                    Ajouter les cordonnées de votre banque
                  </h3>
                </div>
                {/* hereTotal */}

                <DetailBanque />
              </div>
            </div>
          </div>
        </section>
      );
    } else if (type === "BANQUE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">
                  {" "}
                  Ajouter les cordonnées de votre compte caisse{" "}
                </h3>
              </div>
              <DetailBanque />
            </div>
          </div>
        </div>
      );
    }
  }

  const handleChangePayement = (event) => {
    let payement = event.target.value;
    setType(payement);
    console.log("Payement1221", payement);
  };
  console.log("Payement", type);
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                {type === "BANQUE" ? (
                  <li class="breadcrumb-item active">
                    Ajouter Compte 
                  </li>
                ) : (
                  <li class="breadcrumb-item active">Ajouter Compte </li>
                )}
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un compte</h5>
                </div>
                <div className="card-body">
                  <h5 className="card-title">
                    Veuillez choisir le compte désiré
                  </h5>
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                      <select
                        class="form-control"
                        onChange={handleChangePayement}
                      >
                        <option key={1} value={"BANQUE"}>
                          Banque
                        </option>
                        <option key={2} value={"CAISSE"}>
                          Compte caisse
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidAddBankAccount}
                  >
                    Confirmer
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {type === "BANQUE" && <DetailBanque />}
      {type === "CAISSE" && <DetailCompteCaisse />}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      {/* {onConfirmAddWarehouse && (
        <ConfirmAddWarehouse
          setOnConfirmAddWarehouse={setOnConfirmAddWarehouse}
          confirmWarehouseModel={confirmWarehouseModel}
        />
      )} */}
    </div>
  );
};
export default AddBanqueAccount;
